import React, { useState } from "react"
import { Outlet } from "react-router-dom"
import { CorporateHeader } from "./CorporateHeader"
import { CorporateSidebar } from "./CorporateSidebar"
import { AppUseNotification } from "app/pages/component/AppUseNotification"

const CorporateLayout: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)

  const handleToggleSidebar = () => setIsOpen((prev) => !prev)

  return (
    <>
      <AppUseNotification />

      <CorporateSidebar isOpen = {isOpen} HandleOpen = {handleToggleSidebar} />

      <CorporateHeader isOpen={isOpen} />

      <main
        className={`${isOpen ? "pl-52" : "pl-20"} duration-300 bg-white px-8 min-h-screen`}
      >
        <Outlet />
      </main>
    </>
  )
}

export default CorporateLayout
